import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToVolumeChange = (
    volumeChange$: Observable<number>,
    volumeStore: IVolumeStore
): Subscription =>
    volumeChange$
        .subscribe(nextLevel => volumeStore.actions.setLevel(nextLevel));

export default subscribeToVolumeChange;